import PropTypes from 'prop-types';

export const componentStylePropTypes = PropTypes.shape({
    contentBgColor: PropTypes.string,
    contentBorderRadius: PropTypes.number,
    titleFontWeight: PropTypes.number,
    titleColor: PropTypes.string,
    descColor: PropTypes.string,
    answerColor: PropTypes.string,
    optionBgColor: PropTypes.string,
    optionTextColor: PropTypes.string,
    buttonBgColor: PropTypes.string,
    buttonTextColor: PropTypes.string,
    buttonSize: PropTypes.string
});

export const normalizedObjectPropType = PropTypes.shape({
    allIds: PropTypes.array,
    byIds: PropTypes.object
});
